import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

interface Props {
  content?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    content: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-richtext-body",
    innerHTML: __props.content
  }, null, 8, _hoisted_1))
}
}

})